import { render } from "./CompleteProfileView.vue?vue&type=template&id=7864c866&scoped=true"
import script from "./CompleteProfileView.vue?vue&type=script&lang=js"
export * from "./CompleteProfileView.vue?vue&type=script&lang=js"

import "./CompleteProfileView.vue?vue&type=style&index=0&id=7864c866&scoped=true&lang=css"

import exportComponent from "C:\\Users\\mridu\\BGI_Project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7864c866"]])

export default __exports__